<template>
  <div v-if="specificationId">
    <van-tabs v-model="dateMoneyChange" :swipe-threshold="5" @change="onDatePlanMonthChange">
      <van-tab v-for="item in dateMoneyList" :key="item.key" :name="item.key" :title="item.title" :disabled="dateCanUseDaysMonthBegin>item.num|| item.num>dateCanUseDaysMonthEnd" />
    </van-tabs>
    <van-calendar
      :default-date="selectBeginDate"
      :color="GetColorMain()"
      :poppable="false"
      :show-confirm="false"
      :min-date="dateStar"
      :max-date="dateEnd"
      :formatter="formatterDatePlan"
      @select="onSelectDatePlan"
    />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Calendar, Tab, Tabs } from 'vant'
import { formatDate, ShowMoney, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Calendar.name]: Calendar,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  props: {
    // eslint-disable-next-line
    value: String,
    // eslint-disable-next-line
    commodityId:String,
    // eslint-disable-next-line
    beginDate: String
  },
  data() {
    return {
      dateCommodityId: undefined,
      saveDateCommodityId: '',
      specificationId: undefined,
      dateNow: new Date(),
      dateMoneyChange: undefined,
      dateMoneyList: [], // 12个月tab菜单
      dateStar: undefined,
      dateEnd: undefined,
      commodityDatePlanRuleModel: [], // 商品所有日程规则存储
      dateCanUseDays: [], // 可用天数存储
      dateCanUseDaysMonthBegin: 0, // 可用天起于年*100+月份
      dateCanUseDaysMonthEnd: 999999, // 可用天止于年*100+月份
      tripBeginTime: undefined,
      tripEndTime: undefined,
      selectBeginDate: undefined
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.specificationId = newValue
        // console.log('日期计划监听specificationId', this.specificationId)
        this.init()
      } else {
        this.specificationId = undefined
      }
    },
    commodityId(newValue) {
      this.dateCommodityId = newValue
      // console.log('日期计划监听dateCommodityId', this.dateCommodityId)
    },
    beginDate(newValue) {
      if (newValue) {
        if (!(newValue instanceof Date)) {
          this.selectBeginDate = new Date(newValue)
        } else {
          this.selectBeginDate = newValue
        }
      } else {
        this.selectBeginDate = new Date()
      }
      // console.log('日期计划监听beginDate', this.selectBeginDate)
    }
  },
  created() {
    this.initDatePlanMonthChange()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    formatDate,
    init() {
      // console.log('日期计划init', this.dateCommodityId)
      if (this.dateCommodityId !== this.saveDateCommodityId) {
        this.onLoadCommodityDatePlan(this.dateCommodityId, () => {
          this.saveDateCommodityId = this.dateCommodityId
          this.init()
        })
        return
      }
      this.onReadDatePlanDates()
    },
    onClosed() {
      this.$emit('input', false)
    },
    onSelectDatePlan(date) {
      // console.log('onSelectDatePlan', date)
      var time = formatDate(date, 'yyyy/MM/dd')
      this.tripBeginTime = new Date(time)
      this.$emit('select', this.tripBeginTime)
    },
    initDatePlanMonthChange() {
      this.dateNow = new Date()
      this.dateMoneyList = []
      var year = this.dateNow.getFullYear()
      var month = this.dateNow.getMonth() + 1
      for (var i = 0; i < 12; i++) {
        this.dateMoneyList.push({
          num: year * 100 + month,
          title: month + '月',
          value: year + '/' + month + '/1',
          key: year * 100 + month
        })
        if (i === 0) {
          this.dateMoneyChange = year * 100 + month
          // console.log('initDatePlanMonthChange', this.dateMoneyChange)
        }
        month++
        if (month > 12) {
          month = 1
          year++
        }
      }

      this.onDatePlanMonthChange()
    },
    onLoadCommodityDatePlan(id, callback) {
      request({
        url: '/Store/getCommodityDataPlanListUser',
        method: 'post',
        params: { id: id }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.commodityDatePlanRuleModel = response.data
        this.commodityDatePlanRuleModel.forEach(item => {
          if (item.startDate) {
            item.startDate = new Date(item.startDate)
          }
          if (item.finishDate) {
            item.finishDate = new Date(item.finishDate)
          }
        })
        if (callback) {
          callback()
        }
      })
    },
    onReadDatePlanDates() {
      this.dateCanUseDays = []
      this.dateCanUseDaysMonthBegin = 999999
      this.dateCanUseDaysMonthEnd = 0

      var rules = this.commodityDatePlanRuleModel.filter(item => item.specificationId === this.specificationId)
      if (!rules || rules.length <= 0) {
        return
      }
      rules.forEach(dataPlanRule => {
        var today = new Date()
        switch (dataPlanRule.type) {
          case 'FIXED':
            var now1 = new Date(dataPlanRule.dateConfig)
            if (now1 > today) {
              this.handleDateAdd(dataPlanRule, now1, undefined)
            }

            break
          case 'DAY':
            var old = new Date('2020/01/01 00:00:00')
            var strs = dataPlanRule.dateConfig.split(',')
            var spacing = Number(strs[0])
            var offSet = Number(strs[1])
            var v = offSet % (spacing + 1)
            for (var i3 = 0; i3 < 3650; i3++) {
              var now3 = new Date()
              now3 = now3.setDate(today.getDate() + i3)
              now3 = new Date(now3)
              var day = Math.floor((now3 - old) / (24 * 3600 * 1000))
              if (day % (spacing + 1) === v) {
                this.handleDateAdd(dataPlanRule, now3, i3)
              }
            }
            break
          case 'WEEKLY':
            var weekly = dataPlanRule.dateConfig.split(',')
            for (var j = 0; j < weekly.length; j++) {
              weekly[j] = Number(weekly[j])
            }
            for (var i = 0; i < 3650; i++) {
              var now = new Date()
              now = now.setDate(today.getDate() + i)
              now = new Date(now)
              var dayOfWeek = now.getDay()
              if (weekly.filter(item => item === dayOfWeek).length > 0) {
                this.handleDateAdd(dataPlanRule, now, i)
              }
            }
            break
          case 'MONTH':
            var month = dataPlanRule.dateConfig.split(',')
            for (var j2 = 0; j2 < month.length; j2++) {
              month[j2] = Number(month[j2])
            }
            for (var i2 = 0; i2 < 3650; i2++) {
              var now2 = new Date()
              now2 = now2.setDate(today.getDate() + i2)
              now2 = new Date(now2)
              var dayOfMonth = now2.getDate()
              if (month.filter(item => item === dayOfMonth).length > 0) {
                this.handleDateAdd(dataPlanRule, now2, i2)
              }
            }
            break
        }
      })
      setTimeout(() => {
        // console.log('selectBeginDate', this.selectBeginDate)
        if (this.selectBeginDate) {
          var year = this.selectBeginDate.getFullYear()
          var month = this.selectBeginDate.getMonth() + 1
          this.dateMoneyChange = year * 100 + month
        } else {
          this.dateMoneyChange = this.dateCanUseDaysMonthBegin
        }
        // console.log('dateMoneyChange', this.dateMoneyChange)
      }, 50)
    },
    handleDateAdd(dataPlanRule, now, i) {
      var date = formatDate(now, 'yyyy/MM/dd')
      // console.log('A', dataPlanRule.finishDate)
      // console.log('B', now)
      if (dataPlanRule.startDate) {
        if (dataPlanRule.startDate > now) {
          return
        }
      }
      if (dataPlanRule.finishDate) {
        if (dataPlanRule.finishDate < now) {
          return
        }
      }
      if (i !== undefined) {
        if (dataPlanRule.minDateDay && i < dataPlanRule.minDateDay) {
          return
        }
        if (dataPlanRule.maxDateDay && i > dataPlanRule.maxDateDay) {
          return
        }
      }
      var have = this.dateCanUseDays.filter(item => item === date)
      if (have.length <= 0) {
        this.dateCanUseDays.push(date)
        // console.log('添加', date)
        var dayNum = now.getFullYear() * 100 + now.getMonth() + 1
        if (dayNum < this.dateCanUseDaysMonthBegin) {
          this.dateCanUseDaysMonthBegin = dayNum
        }
        if (dayNum > this.dateCanUseDaysMonthEnd) {
          this.dateCanUseDaysMonthEnd = dayNum
        }
      }
    },
    onDatePlanMonthChange() {
      // console.log('onDatePlanMonthChange', this.dateMoneyChange)
      if (!this.dateMoneyChange) {
        return
      }
      var date = this.dateMoneyList.filter(item => item.key === this.dateMoneyChange)
      this.dateStar = new Date(date[0].value)
      var year = this.dateStar.getFullYear()
      var month = this.dateStar.getMonth() + 1
      if (month >= 12) {
        month = 0
        year++
      }
      this.dateEnd = new Date(year, month, 0)
      // console.log('2end', this.selectBeginDate)
    },
    formatterDatePlan(day) {
      var d = formatDate(day.date, 'yyyy/MM/dd')
      var canBuy = this.dateCanUseDays.filter(item => item === d)
      if (canBuy.length <= 0) {
        day.type = 'disabled'
      } else {
        day.bottomInfo = '可选择'
      }

      // const month = day.date.getMonth() + 1
      // const date = day.date.getDate()

      // if (month === 5) {
      //   if (date === 1) {
      //     day.topInfo = '劳动节'
      //   } else if (date === 4) {
      //     day.topInfo = '五四青年节'
      //   } else if (date === 11) {
      //     day.text = '今天'
      //   }
      // }

      // if (day.type === 'start') {
      //   day.bottomInfo = '入住'
      // } else if (day.type === 'end') {
      //   day.bottomInfo = '离店'
      // }
      // if (date === 10) {
      //  day.type = 'disabled'
      // } else {
      //  // day.bottomInfo = '可预订'
      // }
      return day
    }
  }
}
</script>

<style>
.van-calendar__body{
  overflow:hidden !important;
}
</style>
